export default function CheckoutErrors(Basket) {
    let fn = this;

    const bookingErrorModel = {
        error: false,
        bookingId: Basket.getBookingId(),
        type: "", // no-booking-id-in-basket, expired, booking-not-found
    };

    fn.getBookingError = (err) => {
        return { ...bookingErrorModel, ...err };
    };
    return fn;
}
